/**
 * Returns a list of all participles used for the Portuguese passive voice assessment.
 * For each participle, versions for all four possible suffixes (-o, -a, -os, -as) are included.
 * @returns {Array} The list with participles.
 */
export default [
	"ab-rogad",
	"abrogad",
	"abacharelad",
	"abacinad",
	"abafad",
	"abainhad",
	"abaixad",
	"abalad",
	"abalienad",
	"abalroad",
	"abanad",
	"abandad",
	"abandonad",
	"abarbad",
	"abarcad",
	"abarregad",
	"abarrotad",
	"abastardad",
	"abastecid",
	"abatid",
	"abdicad",
	"abduzid",
	"abençoad",
	"aberrad",
	"abert",
	"abespinhad",
	"abestad",
	"abirritad",
	"abismad",
	"abjurad",
	"ablaquead",
	"ablegad",
	"abluíd",
	"abnegad",
	"abobadad",
	"abobad",
	"abocanhad",
	"abolid",
	"abominad",
	"abordad",
	"abortad",
	"abotoad",
	"abraçad",
	"abrandad",
	"abrangid",
	"abrasad",
	"abrasileirad",
	"abreviad",
	"abrigad",
	"abroquelad",
	"abscedid",
	"abscindid",
	"absolutizad",
	"absolvid",
	"absort",
	"absorvid",
	"abstid",
	"abstraíd",
	"abundad",
	"abusad",
	"acabad",
	"acabrunhad",
	"açacalad",
	"academizad",
	"acalentad",
	"acalmad",
	"acamad",
	"acampad",
	"acaramelad",
	"acarditad",
	"acariciad",
	"acarretad",
	"acartad",
	"acastelad",
	"acatad",
	"acautelad",
	"accentuad",
	"acclarad",
	"accolhid",
	"accordad",
	"accreditad",
	"accusad",
	"acedid",
	"aceitad",
	"acelerad",
	"acenad",
	"acendid",
	"acentuad",
	"acerad",
	"acerbad",
	"acercad",
	"acertad",
	"acervad",
	"acessad",
	"acetificad",
	"achad",
	"achanad",
	"achaparrad",
	"achatad",
	"achegad",
	"acicatad",
	"acidificad",
	"acidulad",
	"acinzentad",
	"acionad",
	"acirrad",
	"aclamad",
	"aclarad",
	"aclimad",
	"aclimatad",
	"acobardad",
	"acobertad",
	"açodad",
	"acoimad",
	"açoitad",
	"acolchoad",
	"acolhid",
	"acometid",
	"acomodad",
	"acompanhad",
	"acompridad",
	"aconchegad",
	"acondicionad",
	"aconselhad",
	"acontecid",
	"acoplad",
	"acordad",
	"acorrentad",
	"acortinad",
	"acostad",
	"acostumad",
	"açoutad",
	"acovardad",
	"acreditad",
	"acrescentad",
	"acrescid",
	"acromatizad",
	"activad",
	"actuad",
	"actualizad",
	"açucarad",
	"acudid",
	"açulad",
	"acuminad",
	"acumulad",
	"acusad",
	"adaptad",
	"adelgaçad",
	"adentrad",
	"adequad",
	"aderid",
	"adestrad",
	"adherid",
	"adiad",
	"adiantad",
	"adicionad",
	"adid",
	"aditad",
	"adivinhad",
	"adjetivad",
	"adjudicad",
	"administrad",
	"admirad",
	"admitid",
	"admoestad",
	"adoçad",
	"adocicad",
	"adoecid",
	"adoptad",
	"adorad",
	"adormecid",
	"adornad",
	"adotad",
	"adquirid",
	"adsorvid",
	"adulad",
	"adulterad",
	"aduzid",
	"advertid",
	"advind",
	"advocad",
	"aerad",
	"afadigad",
	"afagad",
	"afamad",
	"afastad",
	"afazendad",
	"afectad",
	"afeiçoad",
	"afeit",
	"aferventad",
	"afetad",
	"afiad",
	"afiançad",
	"afigurad",
	"afilad",
	"afiliad",
	"afinad",
	"afirmad",
	"afivelad",
	"afixad",
	"afligid",
	"aflorad",
	"afluíd",
	"afobad",
	"afogad",
	"afrancesad",
	"afrontad",
	"afrouxad",
	"afugentad",
	"afundad",
	"afundid",
	"agachad",
	"agaload",
	"agarrad",
	"agasalhad",
	"agastad",
	"agendad",
	"agid",
	"agilizad",
	"agitad",
	"aglomerad",
	"aglutinad",
	"agoirad",
	"agoirentad",
	"agoniad",
	"agonizad",
	"agourad",
	"agourentad",
	"agraciad",
	"agradad",
	"agradecid",
	"agrafad",
	"agravad",
	"agredid",
	"agregad",
	"agrilhoad",
	"agrupad",
	"aguad",
	"aguardad",
	"aguçad",
	"aguentad",
	"agüentad",
	"aguilhoad",
	"aguisad",
	"airad",
	"ajeitad",
	"ajoelhad",
	"ajudad",
	"ajuizad",
	"ajuntad",
	"ajustad",
	"alad",
	"alagad",
	"alambicad",
	"alapad",
	"alardead",
	"alargad",
	"alarmad",
	"alastrad",
	"albergad",
	"alçad",
	"alcaguetad",
	"alcalinizad",
	"alcançad",
	"alcatroad",
	"alcoolizad",
	"alcovitad",
	"alcunhad",
	"aleatorizad",
	"alegad",
	"alegorizad",
	"alegrad",
	"aleitad",
	"alentad",
	"alertad",
	"alevantad",
	"alfabetizad",
	"alforriad",
	"algemad",
	"alhead",
	"aliad",
	"alicatead",
	"alicerçad",
	"aliciad",
	"alienad",
	"aligeirad",
	"alijad",
	"alimentad",
	"alinhad",
	"alisad",
	"alistad",
	"aliviad",
	"almejad",
	"almoçad",
	"almoedad",
	"alocad",
	"aloirad",
	"alojad",
	"alongad",
	"alourad",
	"altead",
	"alterad",
	"altercad",
	"alternad",
	"alucinad",
	"aludid",
	"alugad",
	"alumiad",
	"alunad",
	"alunissad",
	"aluviad",
	"alvejad",
	"alvoroçad",
	"alvorotad",
	"amaciad",
	"amad",
	"amadurecid",
	"amainad",
	"amaldiçoad",
	"amalgamad",
	"amamentad",
	"amancebad",
	"amanhad",
	"amanhecid",
	"amansad",
	"amanteigad",
	"amarrad",
	"amassad",
	"amaynad",
	"ameaçad",
	"amead",
	"amealhad",
	"amedorentad",
	"amedrontad",
	"ameigad",
	"amenizad",
	"americanizad",
	"amestrad",
	"amigad",
	"amimad",
	"amnistiad",
	"amofinad",
	"amolad",
	"amolecid",
	"amolentad",
	"amolgad",
	"amontoad",
	"amordaçad",
	"amorenad",
	"amortalhad",
	"amortecid",
	"amortizad",
	"amostrad",
	"amotinad",
	"ampliad",
	"amputad",
	"amuad",
	"amurad",
	"amuralhad",
	"anabolizad",
	"anafad",
	"analisad",
	"anarquizad",
	"anatematizad",
	"ancilosad",
	"ancinhad",
	"ancorad",
	"andad",
	"anestesiad",
	"anexad",
	"angariad",
	"anglicizad",
	"angulad",
	"angustiad",
	"animad",
	"animalizad",
	"aninhad",
	"aniquilad",
	"aniversariad",
	"anodizad",
	"anoitecid",
	"anonimizad",
	"anormalizad",
	"anotad",
	"anquilosad",
	"ansiad",
	"antagonizad",
	"antecipad",
	"antedatad",
	"antepost",
	"antojad",
	"antolhad",
	"antropizad",
	"antropomorfizad",
	"anualizad",
	"anuíd",
	"anulad",
	"anunciad",
	"apagad",
	"apainelad",
	"apaixonad",
	"apalpad",
	"apanhad",
	"apaniguad",
	"aparad",
	"aparafusad",
	"aparatad",
	"aparecid",
	"aparelhad",
	"aparentad",
	"apartad",
	"apassamanad",
	"apatetad",
	"apavorad",
	"apaziguad",
	"apead",
	"apedrejad",
	"apegad",
	"apelad",
	"apelidad",
	"apenad",
	"apensad",
	"apercebid",
	"aperfeiçoad",
	"aperread",
	"apertad",
	"apetecid",
	"apiedad",
	"apimentad",
	"apitad",
	"aplacad",
	"aplainad",
	"aplanad",
	"aplaudid",
	"aplicad",
	"apocopad",
	"apoderad",
	"apodizad",
	"apodrecid",
	"apoiad",
	"apologizad",
	"apontad",
	"apoquentad",
	"aportad",
	"aportuguesad",
	"aposentad",
	"apossad",
	"apostad",
	"apostatad",
	"apostemad",
	"apost",
	"apostrofad",
	"apoteosad",
	"apoteotizad",
	"apoucad",
	"approvad",
	"aprazid",
	"apreciad",
	"apreendid",
	"apregoad",
	"aprendid",
	"apresentad",
	"apressad",
	"aprestad",
	"aprisionad",
	"aprofundad",
	"aprontad",
	"apropriad",
	"aprovad",
	"aproveitad",
	"aprovisionad",
	"aproximad",
	"aprumad",
	"apunhalad",
	"apurad",
	"aquaplanad",
	"aquartelad",
	"aquecid",
	"aquentad",
	"aquiescid",
	"aquietad",
	"arabizad",
	"arad",
	"arbitrad",
	"arborescid",
	"arborizad",
	"arcabuzad",
	"arcad",
	"ardid",
	"aread",
	"arejad",
	"argentad",
	"arguid",
	"argumentad",
	"arianizad",
	"armad",
	"armazenad",
	"aromatizad",
	"arpejad",
	"arpoad",
	"arquead",
	"arquejad",
	"arquitetad",
	"arquivad",
	"arraigad",
	"arrancad",
	"arranhad",
	"arranjad",
	"arrasad",
	"arrastad",
	"arrazoad",
	"arread",
	"arrebanhad",
	"arrebatad",
	"arrebentad",
	"arrebitad",
	"arrecadad",
	"arrecead",
	"arredad",
	"arredondad",
	"arrefecid",
	"arregalad",
	"arreganhad",
	"arreigad",
	"arrematad",
	"arremedad",
	"arremessad",
	"arrendad",
	"arrepanhad",
	"arrestad",
	"arribad",
	"arrimad",
	"arriscad",
	"arrogad",
	"arrojad",
	"arrombad",
	"arrotad",
	"arroubad",
	"arroxead",
	"arruad",
	"arruinad",
	"arrulhad",
	"arrumad",
	"arseniad",
	"arterializad",
	"articulad",
	"artificializad",
	"artilhad",
	"asad",
	"ascendid",
	"asfaltad",
	"asfixiad",
	"asilad",
	"aspirad",
	"assacad",
	"assaltad",
	"assassinad",
	"assead",
	"assediad",
	"assegurad",
	"assemelhad",
	"assenhoread",
	"assentad",
	"assentid",
	"assertad",
	"assestad",
	"assignalad",
	"assimilad",
	"assinad",
	"assinalad",
	"assistid",
	"assoberbad",
	"assobiad",
	"associad",
	"assolad",
	"assomad",
	"assombrad",
	"assoprad",
	"assoread",
	"assossegad",
	"assoviad",
	"assumid",
	"assustad",
	"atacad",
	"atad",
	"atalhad",
	"atanazad",
	"atapetad",
	"atarracad",
	"atarraxad",
	"ataviad",
	"atazanad",
	"atead",
	"atemorizad",
	"atempad",
	"atenazad",
	"atendid",
	"atentad",
	"atenuad",
	"aterrad",
	"aterrissad",
	"aterrorizad",
	"atestad",
	"atiçad",
	"atid",
	"atilad",
	"atinad",
	"atingid",
	"atirad",
	"ativad",
	"atochad",
	"atolad",
	"atomizad",
	"atordoad",
	"atormentad",
	"atracad",
	"atraiçoad",
	"atraíd",
	"atrapalhad",
	"atrasad",
	"atravancad",
	"atravessad",
	"atrelad",
	"atribuíd",
	"atribulad",
	"atritad",
	"atroad",
	"atrofiad",
	"atropelad",
	"attentad",
	"atturad",
	"atuad",
	"atualizad",
	"aturad",
	"auferid",
	"augad",
	"augmentad",
	"augurad",
	"aumentad",
	"aureolad",
	"auscultad",
	"ausentad",
	"autenticad",
	"automatizad",
	"autoproclamad",
	"autorizad",
	"autuad",
	"auxiliad",
	"avaliad",
	"avançad",
	"avariad",
	"avassalad",
	"aventad",
	"aventurad",
	"averbad",
	"avergonhad",
	"averiguad",
	"avermelhad",
	"aviad",
	"avinagrad",
	"avind",
	"avisad",
	"avistad",
	"avivad",
	"aviventad",
	"avoad",
	"azedad",
	"azotad",
	"azulad",
	"azulejad",
	"babad",
	"babujad",
	"bacharelad",
	"bafejad",
	"bailad",
	"bainhad",
	"baixad",
	"bajulad",
	"balad",
	"balançad",
	"balancead",
	"balbuciad",
	"balcanizad",
	"baldad",
	"baldead",
	"balead",
	"balid",
	"balouçad",
	"bambolead",
	"banalizad",
	"bancad",
	"banhad",
	"banquetead",
	"baptizad",
	"baralhad",
	"baratead",
	"barbead",
	"barganhad",
	"barrad",
	"barrid",
	"basead",
	"bastad",
	"bastecid",
	"batalhad",
	"batid",
	"batizad",
	"batucad",
	"bazad",
	"beatificad",
	"bebemorad",
	"bebericad",
	"bebid",
	"beijad",
	"beirad",
	"beliscad",
	"beneficiad",
	"benzid",
	"berrad",
	"besuntad",
	"bicad",
	"bichad",
	"bifurcad",
	"bioacumulad",
	"biotransformad",
	"bisad",
	"bisbilhotad",
	"biscatead",
	"bivacad",
	"blandiciad",
	"blasfemad",
	"blasonad",
	"blefad",
	"blindad",
	"blogad",
	"bloquead",
	"bocejad",
	"boiad",
	"boicotad",
	"bojad",
	"bolad",
	"bombad",
	"bombardead",
	"bombead",
	"borboletead",
	"borbulhad",
	"bordad",
	"borrad",
	"borrifad",
	"botad",
	"botanizad",
	"boxead",
	"bradad",
	"bramid",
	"brandid",
	"branquead",
	"brecad",
	"brigad",
	"brilhad",
	"brincad",
	"brindad",
	"britad",
	"brocad",
	"brochad",
	"bronzead",
	"brotad",
	"bufad",
	"bugad",
	"bulhad",
	"burilad",
	"burlad",
	"burocratizad",
	"buscad",
	"buzinad",
	"cabecead",
	"cabid",
	"cabriolad",
	"caçad",
	"cacarejad",
	"cacetead",
	"cachad",
	"cachead",
	"cacimbad",
	"caçoad",
	"cadastrad",
	"caducad",
	"cafetinad",
	"cagad",
	"caíd",
	"calad",
	"calafetad",
	"calcad",
	"calçad",
	"calcificad",
	"calcinad",
	"calculad",
	"calejad",
	"calhad",
	"calibrad",
	"caluniad",
	"cambad",
	"cambalead",
	"cambiad",
	"caminhad",
	"camuflad",
	"canalizad",
	"cancelad",
	"canonizad",
	"cansad",
	"cantad",
	"cantarolad",
	"capacitad",
	"capad",
	"capinad",
	"capitalizad",
	"capitanead",
	"capitulad",
	"capotad",
	"captad",
	"capturad",
	"caracterizad",
	"caraterizad",
	"carbonizad",
	"cardad",
	"carecid",
	"cariciad",
	"carimbad",
	"carread",
	"carregad",
	"cascatead",
	"casquinad",
	"cassad",
	"castigad",
	"castrad",
	"catad",
	"catalisad",
	"catalizad",
	"catalogad",
	"categorizad",
	"catequizad",
	"cativad",
	"caucionad",
	"causad",
	"cautelad",
	"cauterizad",
	"cavad",
	"cavalgad",
	"cavoucad",
	"cead",
	"cecead",
	"cedid",
	"cegad",
	"ceifad",
	"celebrad",
	"censurad",
	"centelhad",
	"centrad",
	"centralizad",
	"centrifugad",
	"cercad",
	"cerrad",
	"certificad",
	"cerzid",
	"cessad",
	"cevad",
	"chacinad",
	"chacoalhad",
	"chafurdad",
	"chamad",
	"chamuscad",
	"chanfrad",
	"chantagead",
	"chapad",
	"chapead",
	"chatead",
	"checad",
	"chefiad",
	"chegad",
	"cheirad",
	"chiad",
	"chibatad",
	"chibatead",
	"chicanad",
	"chicotead",
	"chifrad",
	"chilread",
	"chimarread",
	"chimarronead",
	"chocad",
	"chocalhad",
	"chorad",
	"choramingad",
	"chouvid",
	"chovid",
	"chufad",
	"chumbad",
	"chupad",
	"chutad",
	"chuviscad",
	"cicatrizad",
	"cifrad",
	"cimentad",
	"cindid",
	"cingid",
	"cintad",
	"cintilad",
	"circulad",
	"circuncidad",
	"circundad",
	"circunscrit",
	"circunstanciad",
	"cisad",
	"cisalhad",
	"cismad",
	"citad",
	"civilizad",
	"clamad",
	"claread",
	"clarificad",
	"classificad",
	"clicad",
	"clonad",
	"clorad",
	"coadjuvad",
	"coad",
	"coagid",
	"coagulad",
	"coalescid",
	"coalhad",
	"coassinad",
	"coaxad",
	"cobert",
	"cobiçad",
	"cobrad",
	"coçad",
	"cocegad",
	"cochichad",
	"cochilad",
	"codificad",
	"coevoluíd",
	"coexistid",
	"cofiad",
	"cogitad",
	"coincidid",
	"coisad",
	"coisificad",
	"coitad",
	"colaborad",
	"colad",
	"colead",
	"colecionad",
	"coletad",
	"colhid",
	"colidid",
	"coligad",
	"coligid",
	"collocad",
	"colmad",
	"colmatad",
	"colocad",
	"colonizad",
	"colorid",
	"comandad",
	"combalid",
	"combatid",
	"combinad",
	"comboiad",
	"começad",
	"comedid",
	"comemorad",
	"comendad",
	"comentad",
	"comercializad",
	"cometid",
	"comichad",
	"comid",
	"cominad",
	"commeçad",
	"comovid",
	"compactad",
	"compadecid",
	"comparad",
	"comparecid",
	"compartilhad",
	"compenetrad",
	"compensad",
	"competid",
	"compilad",
	"complementad",
	"completad",
	"complexad",
	"complicad",
	"comportad",
	"compostad",
	"compost",
	"comprad",
	"compreendid",
	"comprehendid",
	"comprimid",
	"comprometid",
	"comprovad",
	"compulsad",
	"computad",
	"comungad",
	"comunicad",
	"comutad",
	"concatenad",
	"concebid",
	"concedid",
	"concentrad",
	"concernid",
	"concertad",
	"concluíd",
	"concordad",
	"concorrid",
	"concretizad",
	"condecorad",
	"condemnad",
	"condenad",
	"condensad",
	"condicionad",
	"condimentad",
	"conduzid",
	"conectad",
	"confeccionad",
	"conferid",
	"confessad",
	"confiad",
	"configurad",
	"confinad",
	"confirmad",
	"confiscad",
	"conflitad",
	"conformad",
	"confortad",
	"confraternizad",
	"confrontad",
	"confundid",
	"congelad",
	"congestionad",
	"congraçad",
	"congregad",
	"conjecturad",
	"conjeturad",
	"conjugad",
	"conjurad",
	"connectad",
	"conotad",
	"conquistad",
	"consagrad",
	"conseguid",
	"consentid",
	"consertad",
	"conservad",
	"considerad",
	"consignad",
	"consistid",
	"consolad",
	"consolidad",
	"conspirad",
	"conspurcad",
	"constad",
	"constatad",
	"consternad",
	"constituíd",
	"constrangid",
	"construíd",
	"consubstanciad",
	"consultad",
	"consumad",
	"consumid",
	"contactad",
	"contad",
	"contagiad",
	"contaminad",
	"contatad",
	"contemplad",
	"contendid",
	"contentad",
	"contestad",
	"contid",
	"continuad",
	"contornad",
	"contra-atacad",
	"contraatacad",
	"contrabalançad",
	"contrabalancead",
	"contrabandead",
	"contrafeit",
	"contraíd",
	"contrariad",
	"contrastad",
	"contratad",
	"contribuíd",
	"contristad",
	"controlad",
	"conturbad",
	"convalescid",
	"convalidad",
	"convencid",
	"convencionad",
	"conversad",
	"convertid",
	"convidad",
	"convid",
	"convind",
	"convivid",
	"convocad",
	"convulsad",
	"convulsionad",
	"cooperad",
	"coordenad",
	"copiad",
	"copulad",
	"corad",
	"cornead",
	"coroad",
	"correlacionad",
	"correspondid",
	"corricad",
	"corrid",
	"corrigid",
	"corroborad",
	"corrompid",
	"cortad",
	"cortejad",
	"cosid",
	"costead",
	"costumad",
	"costurad",
	"cotad",
	"cotejad",
	"couraçad",
	"cozid",
	"cozinhad",
	"craquead",
	"cravad",
	"cravejad",
	"credenciad",
	"creditad",
	"cremad",
	"crepitad",
	"crescid",
	"crestad",
	"criad",
	"cricrilad",
	"crid",
	"criminalizad",
	"criptografad",
	"crispad",
	"cristalizad",
	"cristianizad",
	"criticad",
	"crochetad",
	"cromad",
	"cronologizad",
	"cronometrad",
	"crucificad",
	"cruzad",
	"cubad",
	"cubicad",
	"cuidad",
	"culminad",
	"culpad",
	"cultivad",
	"cultuad",
	"cumprid",
	"cumprimentad",
	"cumulad",
	"curad",
	"cursad",
	"curtid",
	"curto-circuitad",
	"curtocircuitad",
	"curvad",
	"curvetead",
	"cuspid",
	"custad",
	"custead",
	"custodiad",
	"customizad",
	"cutucad",
	"dadivad",
	"dad",
	"damasquinad",
	"damnad",
	"dançad",
	"danificad",
	"dardejad",
	"datad",
	"datilografad",
	"deambulad",
	"debatid",
	"debicad",
	"debilitad",
	"debitad",
	"debochad",
	"debruçad",
	"debulhad",
	"debutad",
	"debuxad",
	"decaíd",
	"decalcad",
	"decantad",
	"decapitad",
	"dececionad",
	"decepad",
	"decepcionad",
	"decidid",
	"decifrad",
	"declamad",
	"declarad",
	"declinad",
	"decolad",
	"decompost",
	"decorad",
	"decorrid",
	"decotad",
	"decrescid",
	"decretad",
	"decuplicad",
	"dedicad",
	"dedilhad",
	"dedurad",
	"deduzid",
	"defecad",
	"defendid",
	"defenestrad",
	"deferid",
	"definhad",
	"definid",
	"deflorad",
	"deformad",
	"defraudad",
	"defumad",
	"deglaçad",
	"deglacead",
	"deglutid",
	"degolad",
	"degradad",
	"degustad",
	"deificad",
	"deitad",
	"deixad",
	"delatad",
	"delegad",
	"deliberad",
	"deliciad",
	"delid",
	"delimitad",
	"delinead",
	"delinquid",
	"delongad",
	"demandad",
	"demarcad",
	"demitid",
	"demittid",
	"democratizad",
	"demolid",
	"demonstrad",
	"demorad",
	"denigrid",
	"denominad",
	"denotad",
	"dentad",
	"dentead",
	"denunciad",
	"deparad",
	"depauperad",
	"depenad",
	"dependid",
	"depilad",
	"deportad",
	"depositad",
	"depost",
	"deprecad",
	"depreciad",
	"depredad",
	"deprimid",
	"depurad",
	"deputad",
	"derivad",
	"derrabad",
	"derramad",
	"derrapad",
	"derretid",
	"derribad",
	"derrocad",
	"derrogad",
	"derrotad",
	"derrubad",
	"derruíd",
	"desabad",
	"desabafad",
	"desabalroad",
	"desabilitad",
	"desabituad",
	"desabotoad",
	"desabraçad",
	"desabrochad",
	"desacelerad",
	"desacompanhad",
	"desaconselhad",
	"desacreditad",
	"desactivad",
	"desafiad",
	"desafivelad",
	"desafogad",
	"desagradad",
	"desagradecid",
	"desagravad",
	"desagregad",
	"desaguisad",
	"desajustad",
	"desalentad",
	"desalojad",
	"desalvorad",
	"desamarrad",
	"desamparad",
	"desancorad",
	"desandad",
	"desanimad",
	"desaparecid",
	"desapegad",
	"desapontad",
	"desaprovad",
	"desarmad",
	"desarraigad",
	"desarranjad",
	"desarrazoad",
	"desarrumad",
	"desarticulad",
	"desarvorad",
	"desasad",
	"desatad",
	"desatarraxad",
	"desativad",
	"desbastad",
	"desbloquead",
	"desbotad",
	"descabelad",
	"descaíd",
	"descalçad",
	"descamad",
	"descambad",
	"descansad",
	"descarbonizad",
	"descarnad",
	"descaroçad",
	"descarregad",
	"descarrilad",
	"descartad",
	"descascad",
	"descendid",
	"descercad",
	"descid",
	"descobert",
	"descolad",
	"descolonizad",
	"descolorid",
	"descomplicad",
	"descompost",
	"desconcertad",
	"desconfiad",
	"desconfortad",
	"descongelad",
	"desconsagrad",
	"desconseguid",
	"desconsiderad",
	"desconsolad",
	"descontad",
	"descontentad",
	"desconversad",
	"desconvidad",
	"descoroçoad",
	"descortinad",
	"descrit",
	"descubert",
	"descuidad",
	"desculpad",
	"desdemocratizad",
	"desdenhad",
	"desdobrad",
	"desejad",
	"desemaranhad",
	"desembalad",
	"desembarcad",
	"desembargad",
	"desembestad",
	"desempenhad",
	"desencadead",
	"desencaminhad",
	"desencantad",
	"desencontrad",
	"desencorajad",
	"desencriptad",
	"desenganad",
	"desenhad",
	"desenrolad",
	"desenterrad",
	"desentranhad",
	"desenvolvid",
	"desequilibrad",
	"deserdad",
	"desertad",
	"desesperad",
	"desesperançad",
	"desestabilizad",
	"deseuropeizad",
	"desfalcad",
	"desfalecid",
	"desfarçad",
	"desfechad",
	"desfeit",
	"desferid",
	"desfiad",
	"desfigurad",
	"desfivelad",
	"desflorestad",
	"desfocad",
	"desfragmentad",
	"desfraldad",
	"desfrutad",
	"desgastad",
	"desgostad",
	"desidratad",
	"designad",
	"desiludid",
	"desimpedid",
	"desinfetad",
	"desinflad",
	"desinstalad",
	"desintegrad",
	"desintoxicad",
	"desistid",
	"desjejuad",
	"deslastrad",
	"deslavad",
	"desleixad",
	"desligad",
	"deslizad",
	"deslocad",
	"deslocalizad",
	"deslogad",
	"deslumbrad",
	"deslustrad",
	"desmagnetizad",
	"desmaiad",
	"desmamad",
	"desmanchad",
	"desmantelad",
	"desmarcad",
	"desmatad",
	"desmembrad",
	"desmentid",
	"desmerecid",
	"desmistificad",
	"desmitificad",
	"desmobilizad",
	"desmontad",
	"desmoralizad",
	"desmoronad",
	"desmotivad",
	"desnivelad",
	"desnortead",
	"desobrigad",
	"desobstruíd",
	"desocupad",
	"desolad",
	"desonerad",
	"desonrad",
	"desordenad",
	"desorganizad",
	"desorientad",
	"desossad",
	"desovad",
	"desoxidad",
	"desoxigenad",
	"despachad",
	"despadronizad",
	"despedaçad",
	"despedid",
	"despejad",
	"despelad",
	"despencad",
	"despendid",
	"desperdiçad",
	"despersuadid",
	"despertad",
	"despid",
	"despojad",
	"despolarizad",
	"despontad",
	"desposad",
	"despregad",
	"desprendid",
	"desprezad",
	"desproporcionad",
	"desprotegid",
	"desprovid",
	"desqualificad",
	"desregulad",
	"desrespeitad",
	"dessalinizad",
	"desseguid",
	"dessulfurad",
	"dessulfurizad",
	"destacad",
	"destelhad",
	"desterrad",
	"destilad",
	"destillad",
	"destinad",
	"destituíd",
	"destoad",
	"destrancad",
	"destratad",
	"destrinçad",
	"destrinchad",
	"destroçad",
	"destruíd",
	"destrunfad",
	"desumanizad",
	"desunid",
	"desvairad",
	"desvalorizad",
	"desvelad",
	"desvendad",
	"desviad",
	"desvinculad",
	"desvirginad",
	"desvirtuad",
	"detalhad",
	"detectad",
	"deteriorad",
	"determinad",
	"detestad",
	"detetad",
	"detid",
	"detonad",
	"devanead",
	"devassad",
	"devastad",
	"devid",
	"devolvid",
	"devorad",
	"devotad",
	"deyxad",
	"diagnosticad",
	"dialogad",
	"difamad",
	"diferenciad",
	"diferid",
	"differid",
	"dificultad",
	"difratad",
	"difundid",
	"digerid",
	"digitad",
	"digitalizad",
	"dignad",
	"dilacerad",
	"dilapidad",
	"dilatad",
	"diluíd",
	"diminuíd",
	"dinamitad",
	"dinamizad",
	"diplomad",
	"direccionad",
	"direcionad",
	"dirigid",
	"dirimid",
	"discad",
	"discernid",
	"disciplinad",
	"discordad",
	"discorrid",
	"discretead",
	"discriminad",
	"discutid",
	"disfarçad",
	"disparad",
	"dispensad",
	"dispersad",
	"disponibilizad",
	"dispost",
	"disputad",
	"dissecad",
	"disseminad",
	"dissentid",
	"dissimulad",
	"dissipad",
	"dissolvid",
	"dissuadid",
	"distad",
	"distanciad",
	"distinguid",
	"distorcid",
	"distraíd",
	"distratad",
	"distribuíd",
	"ditad",
	"dit",
	"divagad",
	"diversificad",
	"divertid",
	"dividid",
	"divisad",
	"divulgad",
	"dizimad",
	"doad",
	"dobrad",
	"doíd",
	"domad",
	"domesticad",
	"domiciliad",
	"dominad",
	"dopad",
	"dormid",
	"dormitad",
	"dosad",
	"dotad",
	"doutrinad",
	"dragad",
	"dramatizad",
	"drenad",
	"driblad",
	"drogad",
	"dublad",
	"duchad",
	"duelad",
	"duplicad",
	"durad",
	"duvidad",
	"eclipsad",
	"ecoad",
	"economizad",
	"edificad",
	"editad",
	"educad",
	"efectivad",
	"efectuad",
	"efetivad",
	"efetuad",
	"eivad",
	"ejaculad",
	"ejetad",
	"elaborad",
	"electrificad",
	"electrocutad",
	"elegid",
	"eleit",
	"elencad",
	"eletrificad",
	"eletrocutad",
	"eletrolisad",
	"elevad",
	"eliminad",
	"elogiad",
	"elucidad",
	"elucubrad",
	"eludid",
	"emaciad",
	"emagrecid",
	"emanad",
	"emancipad",
	"emaranhad",
	"emasculad",
	"embaíd",
	"embainhad",
	"embalad",
	"embalsamad",
	"embaraçad",
	"embaralhad",
	"embarcad",
	"embasad",
	"embebedad",
	"embebid",
	"embeiçad",
	"embelezad",
	"embirrad",
	"embolad",
	"embonecad",
	"emboscad",
	"embotad",
	"embotelhad",
	"embrenhad",
	"embriagad",
	"embromad",
	"embrulhad",
	"embuçad",
	"emburrad",
	"emburrecid",
	"embutid",
	"emendad",
	"ementad",
	"emergid",
	"emigrad",
	"emitid",
	"emmagrecid",
	"emmoldurad",
	"emocionad",
	"emoldurad",
	"empachad",
	"empacotad",
	"empalad",
	"empalhad",
	"empalidecid",
	"empanad",
	"empapelad",
	"emparedad",
	"empatad",
	"empeçonhad",
	"empedernid",
	"empenhad",
	"emperrad",
	"empestead",
	"empilhad",
	"empinad",
	"empiorad",
	"empoad",
	"empobrecid",
	"empoderad",
	"empoleirad",
	"empreendid",
	"empregad",
	"empregu",
	"emprehendid",
	"empreitad",
	"emprenhad",
	"emprestad",
	"empunhad",
	"empurrad",
	"emudecid",
	"emulad",
	"emurchecid",
	"enaltecid",
	"enamorad",
	"encabulad",
	"encaçapad",
	"encadead",
	"encadernad",
	"encaixad",
	"encaixilhad",
	"encaixotad",
	"encalhad",
	"encaminhad",
	"encampad",
	"encanad",
	"encantad",
	"encapad",
	"encapsulad",
	"encapuzad",
	"encaracolad",
	"encarad",
	"encarecid",
	"encarnad",
	"encarniçad",
	"encaroçad",
	"encarquilhad",
	"encarregad",
	"encarregu",
	"encarrilhad",
	"encasquetad",
	"encayxad",
	"encefalizad",
	"encenad",
	"encerad",
	"encerrad",
	"encestad",
	"encetad",
	"encharcad",
	"enchid",
	"enclausurad",
	"encobert",
	"encoleirad",
	"encolerizad",
	"encolhid",
	"encomendad",
	"encompridad",
	"encontrad",
	"encorajad",
	"encordoad",
	"encorpad",
	"encortinad",
	"encostad",
	"encravad",
	"encrespad",
	"encriptad",
	"encurtad",
	"endereçad",
	"endireitad",
	"endividad",
	"endoidecid",
	"endossad",
	"endoutrinad",
	"endurecid",
	"enegrecid",
	"energizad",
	"enervad",
	"enevoad",
	"enfardad",
	"enfardelad",
	"enfarruscad",
	"enfatizad",
	"enfatuad",
	"enfeitad",
	"enfeitiçad",
	"enferrujad",
	"enfiad",
	"enfileirad",
	"enforcad",
	"enfraquecid",
	"enfrentad",
	"enfronhad",
	"enfumaçad",
	"enfurecid",
	"engabelad",
	"engaiolad",
	"engajad",
	"engambelad",
	"enganad",
	"enganchad",
	"engarrafad",
	"engasgad",
	"engastad",
	"engatad",
	"engatinhad",
	"engendrad",
	"engessad",
	"englobad",
	"engodad",
	"engolid",
	"engomad",
	"engordad",
	"engordurad",
	"engrandecid",
	"engravidad",
	"engraxad",
	"engrenad",
	"engrossad",
	"enguiçad",
	"enlaçad",
	"enlatad",
	"enlouquecid",
	"enmendad",
	"enquadrad",
	"enraivecid",
	"enraizad",
	"enramalhetad",
	"enredad",
	"enriçad",
	"enriquecid",
	"enrocad",
	"enrolad",
	"enrubescid",
	"enrugad",
	"ensaboad",
	"ensacad",
	"ensaiad",
	"ensanguentad",
	"ensangüentad",
	"ensejad",
	"ensinad",
	"ensolarad",
	"ensombrad",
	"ensopad",
	"ensurdecid",
	"entabuad",
	"entabulad",
	"entalhad",
	"entardecid",
	"entediad",
	"entelhad",
	"entendid",
	"enternecid",
	"enterrad",
	"entintad",
	"entitulad",
	"entoad",
	"entornad",
	"entorpecid",
	"entortad",
	"entrad",
	"entrançad",
	"entranhad",
	"entravad",
	"entreabert",
	"entrecortad",
	"entregad",
	"entregu",
	"entrelaçad",
	"entrelinhad",
	"entremead",
	"entreolhad",
	"entretid",
	"entrevad",
	"entrevistad",
	"entrevist",
	"entrincheirad",
	"entristecid",
	"entronad",
	"entronizad",
	"entulhad",
	"entupid",
	"entusiasmad",
	"enumerad",
	"enunciad",
	"envelhecid",
	"envenenad",
	"envergad",
	"envergonhad",
	"envernizad",
	"enviad",
	"enviesad",
	"enviuvad",
	"envolvid",
	"enxadad",
	"enxamead",
	"enxergad",
	"enxertad",
	"enxotad",
	"enxugad",
	"enxut",
	"epitomizad",
	"equilibrad",
	"equipad",
	"equiparad",
	"equivocad",
	"erguid",
	"erigid",
	"erodid",
	"erotizad",
	"erradicad",
	"eructad",
	"esbarrad",
	"esbatid",
	"esboçad",
	"esbodegad",
	"esbofetead",
	"esbombardead",
	"esbracejad",
	"esbrasead",
	"esbulhad",
	"esburacad",
	"escachoad",
	"escalad",
	"escaldad",
	"escalfad",
	"escalonad",
	"escalpad",
	"escalpelad",
	"escamad",
	"escançad",
	"escancarad",
	"escancead",
	"escandid",
	"escanead",
	"escapad",
	"escapulid",
	"escarafunchad",
	"escaramuçad",
	"escarnecid",
	"escarnid",
	"escarrad",
	"escassead",
	"escavad",
	"esclarecid",
	"escoad",
	"escolarizad",
	"escolhid",
	"escoltad",
	"escondid",
	"escorad",
	"escorregad",
	"escorrid",
	"escovad",
	"escravizad",
	"escrit",
	"escriturad",
	"escrutinizad",
	"escuitad",
	"esculachad",
	"esculpid",
	"escurecid",
	"escusad",
	"escutad",
	"esfalfad",
	"esfaquead",
	"esfarelad",
	"esfarrapad",
	"esfolad",
	"esfomead",
	"esforçad",
	"esfregad",
	"esfriad",
	"esfuziad",
	"esganad",
	"esgarçad",
	"esgotad",
	"esgravatad",
	"esgrimid",
	"esguichad",
	"esmaecid",
	"esmagad",
	"esmaltad",
	"esmerad",
	"esmigalhad",
	"esmiuçad",
	"esmorecid",
	"esmurrad",
	"espaçad",
	"espacead",
	"espairecid",
	"espalhad",
	"espalmad",
	"espancad",
	"espantad",
	"esparramad",
	"especializad",
	"especificad",
	"especulad",
	"espedid",
	"espelhad",
	"esperad",
	"esperançad",
	"espernead",
	"espezinhad",
	"espiad",
	"espichad",
	"espigad",
	"espinafrad",
	"espionad",
	"espiritualizad",
	"espirrad",
	"espocad",
	"espojad",
	"esporrad",
	"esposad",
	"espoucad",
	"espreitad",
	"espremid",
	"espumad",
	"esquadrinhad",
	"esquecid",
	"esquentad",
	"esquiad",
	"esquilad",
	"esquinad",
	"esquivad",
	"estabelecid",
	"estabilizad",
	"estacad",
	"estacionad",
	"estad",
	"estafad",
	"estagiad",
	"estagnad",
	"estalad",
	"estampad",
	"estandardizad",
	"estanhad",
	"estarrecid",
	"estatizad",
	"estatuíd",
	"estendid",
	"estenografad",
	"estenographad",
	"estereotipad",
	"esterilizad",
	"esticad",
	"estigmatizad",
	"estilhaçad",
	"estilizad",
	"estimad",
	"estimulad",
	"estiolad",
	"estipulad",
	"estirad",
	"estivad",
	"estocad",
	"estoirad",
	"estolad",
	"estontead",
	"estorvad",
	"estourad",
	"estraçalhad",
	"estragad",
	"estralad",
	"estrangulad",
	"estranhad",
	"estratificad",
	"estread",
	"estreiad",
	"estreitad",
	"estrelad",
	"estremecid",
	"estressad",
	"estridulad",
	"estripad",
	"estrondead",
	"estropead",
	"estropiad",
	"estrugid",
	"estrupidad",
	"estruturad",
	"estudad",
	"estufad",
	"estupeficad",
	"estupidificad",
	"estuprad",
	"esvaziad",
	"esverdead",
	"etiquetad",
	"europeizad",
	"evacuad",
	"evadid",
	"evangelizad",
	"evaporad",
	"eventrad",
	"evidenciad",
	"evitad",
	"evocad",
	"evolad",
	"evoluíd",
	"evolvid",
	"exacerbad",
	"exagerad",
	"exalad",
	"exaltad",
	"examinad",
	"exasperad",
	"exaurid",
	"excedid",
	"excelid",
	"excellid",
	"excepcionad",
	"exceptuad",
	"excetuad",
	"excitad",
	"exclamad",
	"excluíd",
	"excomungad",
	"excretad",
	"excutid",
	"executad",
	"exercid",
	"exercitad",
	"exhalad",
	"exhortad",
	"exibid",
	"exigid",
	"exilad",
	"eximid",
	"existid",
	"exonerad",
	"exorcizad",
	"exortad",
	"expandid",
	"expatriad",
	"expectorad",
	"expedid",
	"experienciad",
	"experimentad",
	"expirad",
	"explanad",
	"explicad",
	"explorad",
	"exportad",
	"expost",
	"expressad",
	"exprimid",
	"expropriad",
	"expugnad",
	"expulsad",
	"expurgad",
	"exsecutad",
	"extasiad",
	"extendid",
	"extenuad",
	"exteriorizad",
	"exterminad",
	"externalizad",
	"extinguid",
	"extint",
	"extirpad",
	"extorquid",
	"extractad",
	"extraditad",
	"extraíd",
	"extratad",
	"extraviad",
	"exultad",
	"exumad",
	"fabricad",
	"facetad",
	"facilitad",
	"facturad",
	"facultad",
	"fadigad",
	"fagocitad",
	"fagulhad",
	"falad",
	"falecid",
	"falhad",
	"fallad",
	"falsead",
	"falsificad",
	"faltad",
	"familiarizad",
	"fantasiad",
	"fardad",
	"farejad",
	"farfalhad",
	"fartad",
	"fascinad",
	"fatiad",
	"fatigad",
	"fatorad",
	"faturad",
	"faxinad",
	"fechad",
	"fech",
	"fecundad",
	"fedid",
	"feit",
	"felicitad",
	"fenad",
	"fendid",
	"fenecid",
	"ferid",
	"fermentad",
	"ferrad",
	"fertilizad",
	"fervid",
	"fervilhad",
	"festad",
	"festejad",
	"fiad",
	"ficad",
	"figurad",
	"filad",
	"filiad",
	"filmad",
	"filosofad",
	"filtrad",
	"finad",
	"finalizad",
	"financiad",
	"fincad",
	"findad",
	"find",
	"fingid",
	"finlandizad",
	"firmad",
	"fiscalizad",
	"fisgad",
	"fissionad",
	"fissurad",
	"fitad",
	"fixad",
	"flabelad",
	"flagelad",
	"flanquead",
	"flexionad",
	"flipad",
	"floodad",
	"floread",
	"florescid",
	"fluíd",
	"fluorad",
	"fluoretad",
	"flutuad",
	"focalizad",
	"fodid",
	"fofocad",
	"folgad",
	"folhead",
	"fomentad",
	"foragid",
	"forcad",
	"forçad",
	"forjad",
	"formad",
	"formatad",
	"formigad",
	"formulad",
	"fornecid",
	"fornicad",
	"forrad",
	"fortalecid",
	"fortificad",
	"fosfatad",
	"fosforescid",
	"fosforilad",
	"fossad",
	"fotocopiad",
	"fotografad",
	"fraccionad",
	"fracionad",
	"fragmentad",
	"franjad",
	"franquead",
	"franzid",
	"fraquead",
	"fraquejad",
	"frasead",
	"fraternizad",
	"fraturad",
	"fraudad",
	"fread",
	"freiad",
	"frequentad",
	"freqüentad",
	"fresquead",
	"friccionad",
	"frisad",
	"fritad",
	"frit",
	"fruíd",
	"frustrad",
	"fuçad",
	"fugid",
	"fumad",
	"fumegad",
	"fumigad",
	"funccionad",
	"funcionad",
	"fundad",
	"fundamentad",
	"fundid",
	"fungad",
	"furad",
	"furtad",
	"fusionad",
	"fustigad",
	"futricad",
	"fuzilad",
	"gabad",
	"gadanhad",
	"gaguejad",
	"galgad",
	"galopad",
	"galopead",
	"galvanizad",
	"gamad",
	"ganhad",
	"ganh",
	"ganid",
	"ganzad",
	"garantid",
	"gargalhad",
	"gargarejad",
	"gaseificad",
	"gastad",
	"gast",
	"gatunad",
	"gelad",
	"gemid",
	"generalizad",
	"genotipad",
	"gerad",
	"gerenciad",
	"gerid",
	"germinad",
	"gestad",
	"gesticulad",
	"gestualizad",
	"ginasticad",
	"girad",
	"globalizad",
	"gloriad",
	"glorificad",
	"glosad",
	"golead",
	"golpead",
	"gomitad",
	"googlad",
	"gorad",
	"gorjead",
	"gostad",
	"gotejad",
	"governad",
	"gozad",
	"gracejad",
	"gracitad",
	"gradad",
	"graduad",
	"grafitad",
	"gramad",
	"grampead",
	"granizad",
	"grasnad",
	"grasnid",
	"grassitad",
	"gratificad",
	"gratinad",
	"gravad",
	"gravitad",
	"grelhad",
	"gripad",
	"gritad",
	"grudad",
	"grunhid",
	"guardad",
	"guarnecid",
	"guerread",
	"guglad",
	"guiad",
	"guinchad",
	"guindad",
	"guisad",
	"habilitad",
	"habitad",
	"habituad",
	"hackead",
	"halogenad",
	"harmonizad",
	"hastead",
	"havid",
	"helenizad",
	"herdad",
	"hesitad",
	"hibernad",
	"hibridizad",
	"hidratad",
	"hidrogenad",
	"hipertrofiad",
	"hipnotizad",
	"hipotecad",
	"homenagead",
	"homogeneizad",
	"homologad",
	"honrad",
	"horrorizad",
	"hortad",
	"hospedad",
	"hospitalizad",
	"humedecid",
	"humidecid",
	"humilhad",
	"içad",
	"idead",
	"idealizad",
	"identificad",
	"ideologizad",
	"idolatrad",
	"ignorad",
	"igualad",
	"ilegalizad",
	"ilhad",
	"ilibad",
	"ilidid",
	"iludid",
	"iluminad",
	"ilustrad",
	"imaginad",
	"imanad",
	"imantad",
	"imbuíd",
	"imigrad",
	"imiscuíd",
	"imitad",
	"imobilizad",
	"imolad",
	"impactad",
	"impedid",
	"impelid",
	"imperad",
	"impetrad",
	"implantad",
	"implementad",
	"implicad",
	"implorad",
	"importad",
	"importunad",
	"impossibilitad",
	"impost",
	"imprecad",
	"impregnad",
	"impressionad",
	"impress",
	"imprimid",
	"improvisad",
	"impulsionad",
	"imputad",
	"imunizad",
	"inactivad",
	"inalad",
	"inaugurad",
	"incapacitad",
	"incendiad",
	"incensad",
	"incentivad",
	"inchad",
	"incidid",
	"incinerad",
	"incisad",
	"incitad",
	"inclinad",
	"incluíd",
	"inclus",
	"incomodad",
	"incorporad",
	"incorrid",
	"incriminad",
	"incrustad",
	"incubad",
	"inculcad",
	"inculpad",
	"incumbid",
	"indagad",
	"indeferid",
	"indefinid",
	"indemnizad",
	"indenizad",
	"independid",
	"indexad",
	"indicad",
	"indiciad",
	"indispost",
	"indultad",
	"industrializad",
	"induzid",
	"inebriad",
	"inerid",
	"infectad",
	"inferid",
	"infestad",
	"infiltrad",
	"infirmad",
	"inflad",
	"inflamad",
	"influenciad",
	"influíd",
	"informad",
	"infringid",
	"ingerid",
	"inhibid",
	"inibid",
	"iniciad",
	"inicializad",
	"injetad",
	"injungid",
	"injuriad",
	"injustiçad",
	"inocentad",
	"inovad",
	"inquietad",
	"inquirid",
	"inscrit",
	"inserid",
	"insinuad",
	"insistid",
	"inspecionad",
	"inspirad",
	"instalad",
	"instanciad",
	"instigad",
	"instituíd",
	"instruíd",
	"insultad",
	"integrad",
	"inteirad",
	"intencionad",
	"intensificad",
	"interagid",
	"intercalad",
	"intercambiad",
	"intercedid",
	"interceptad",
	"interditad",
	"interessad",
	"interferid",
	"interligad",
	"intermediad",
	"internacionalizad",
	"internad",
	"interpelad",
	"interpolad",
	"interpost",
	"interpretad",
	"interrogad",
	"interrompid",
	"intersectad",
	"intervind",
	"intimad",
	"intimidad",
	"intitulad",
	"intoxicad",
	"intricad",
	"intrigad",
	"intrincad",
	"introduzid",
	"intrometid",
	"inundad",
	"inutilizad",
	"invadid",
	"invalidad",
	"invectivad",
	"invejad",
	"inventad",
	"invernad",
	"invertid",
	"investid",
	"investigad",
	"invocad",
	"iodad",
	"irad",
	"irradiad",
	"irrigad",
	"irritad",
	"irrogad",
	"irrompid",
	"iscad",
	"isolad",
	"iterad",
	"jactad",
	"janelad",
	"jantad",
	"japonizad",
	"jardinad",
	"jazid",
	"jejuad",
	"joeirad",
	"jogad",
	"jorrad",
	"jubilad",
	"judiad",
	"julgad",
	"jungid",
	"juntad",
	"jurad",
	"juramentad",
	"justapost",
	"justificad",
	"labutad",
	"laçad",
	"lacrad",
	"lacrimejad",
	"ladead",
	"ladrilhad",
	"lagartead",
	"lajead",
	"lambid",
	"lamentad",
	"laminad",
	"lamuriad",
	"lançad",
	"lancead",
	"lanchad",
	"lapidad",
	"largad",
	"lascad",
	"lastad",
	"lastimad",
	"latejad",
	"latid",
	"latinad",
	"latinizad",
	"lavad",
	"lavrad",
	"lẽbrad",
	"legad",
	"legalizad",
	"legendad",
	"legislad",
	"legitimad",
	"leiload",
	"lembrad",
	"lesad",
	"levad",
	"levantad",
	"levitad",
	"liberad",
	"libertad",
	"licitad",
	"lidad",
	"liderad",
	"lid",
	"ligad",
	"limad",
	"limitad",
	"limpad",
	"limp",
	"linchad",
	"lingotad",
	"liquefeit",
	"liquidad",
	"lisonjad",
	"lisonjead",
	"listad",
	"listrad",
	"litigad",
	"livrad",
	"lixiviad",
	"lobrigad",
	"locad",
	"localizad",
	"locupletad",
	"lograd",
	"lotad",
	"lotead",
	"louvad",
	"lubrificad",
	"lucrad",
	"luctad",
	"ludibriad",
	"ludificad",
	"lufad",
	"luitad",
	"lustrad",
	"lutad",
	"luzid",
	"macadamizad",
	"maçad",
	"macaquead",
	"macerad",
	"machucad",
	"maculad",
	"mãdad",
	"madrugad",
	"madurad",
	"magnetizad",
	"magnificad",
	"magoad",
	"maiusculad",
	"maiusculizad",
	"malograd",
	"maltad",
	"maltratad",
	"mamad",
	"manad",
	"mancad",
	"manchad",
	"mandad",
	"manejad",
	"manifestad",
	"manipulad",
	"manjad",
	"mantid",
	"manufaturad",
	"manusead",
	"maquiad",
	"maquinad",
	"marcad",
	"marchad",
	"marejad",
	"marinad",
	"marquetead",
	"marretad",
	"martelad",
	"martirizad",
	"mascad",
	"mascarad",
	"mascatead",
	"massacrad",
	"massagead",
	"mastigad",
	"masturbad",
	"matad",
	"matriculad",
	"maturad",
	"maximizad",
	"maxixad",
	"mead",
	"mealhad",
	"mecanizad",
	"medid",
	"meditad",
	"medrad",
	"melad",
	"melhorad",
	"memorizad",
	"mencionad",
	"mendigad",
	"menead",
	"menosprezad",
	"menstruad",
	"mentid",
	"mercad",
	"merecid",
	"mergulhad",
	"mesclad",
	"mesmerizad",
	"metabolizad",
	"metid",
	"metilad",
	"metralhad",
	"mexericad",
	"mexid",
	"miad",
	"micad",
	"migrad",
	"mijad",
	"milhad",
	"militad",
	"mimad",
	"mimetizad",
	"mimid",
	"minad",
	"minerad",
	"mineralizad",
	"minimizad",
	"ministrad",
	"minuciad",
	"minudenciad",
	"mirad",
	"mirrad",
	"missad",
	"mistificad",
	"misturad",
	"mitigad",
	"mixad",
	"mixturad",
	"mobilizad",
	"modelad",
	"moderad",
	"modificad",
	"modulad",
	"mofad",
	"moíd",
	"moldad",
	"molestad",
	"molhad",
	"monitorad",
	"monitorizad",
	"monologad",
	"monopolizad",
	"montad",
	"morad",
	"mordid",
	"mordiscad",
	"morgad",
	"morrid",
	"mortificad",
	"mort",
	"moscad",
	"moshad",
	"mosquead",
	"mossegad",
	"mostrad",
	"motejad",
	"motivad",
	"mourejad",
	"movid",
	"movimentad",
	"mudad",
	"mugid",
	"multad",
	"multiplicad",
	"mumificad",
	"munid",
	"murad",
	"murchad",
	"murmurad",
	"mutilad",
	"nacionalizad",
	"nadad",
	"nad",
	"narrad",
	"nasalad",
	"nascid",
	"naufragad",
	"navegad",
	"necessitad",
	"negad",
	"negligenciad",
	"negociad",
	"neutralizad",
	"nevad",
	"nhanhad",
	"niponizad",
	"niquelad",
	"nitrificad",
	"nivelad",
	"nobilitad",
	"nocautead",
	"nomead",
	"normalizad",
	"notad",
	"noticiad",
	"notificad",
	"nublad",
	"numerad",
	"numerizad",
	"nutrid",
	"obcecad",
	"obedecid",
	"objetad",
	"objetivad",
	"obnubilad",
	"obrad",
	"obrigad",
	"obscurecid",
	"observad",
	"obstinad",
	"obstruíd",
	"obtemperad",
	"obtid",
	"obturad",
	"obviad",
	"ocasionad",
	"occorrid",
	"ocorrid",
	"ocultad",
	"ocupad",
	"odiad",
	"odorizad",
	"ofegad",
	"ofendid",
	"oferecid",
	"oficializad",
	"ofuscad",
	"oitavad",
	"olead",
	"olhad",
	"olvidad",
	"omitid",
	"ondead",
	"ondulad",
	"onerad",
	"operad",
	"opinad",
	"opiniad",
	"opost",
	"opprimid",
	"oprimid",
	"optad",
	"optimizad",
	"orad",
	"orbitad",
	"orçad",
	"ordenad",
	"ordenhad",
	"organizad",
	"orgulhad",
	"orientad",
	"orientalizad",
	"originad",
	"orlad",
	"ornad",
	"ornamentad",
	"orquestrad",
	"oscilad",
	"ostentad",
	"ostracizad",
	"otimizad",
	"ouriçad",
	"ousad",
	"outorgad",
	"ouvid",
	"ouvist",
	"ovulad",
	"oxidad",
	"oxigenad",
	"ozonizad",
	"pacificad",
	"pactad",
	"pactuad",
	"padecid",
	"padronizad",
	"pagad",
	"paginad",
	"pag",
	"pairad",
	"pajead",
	"palead",
	"palestrad",
	"palpad",
	"palpitad",
	"palrad",
	"panad",
	"papad",
	"papaguead",
	"paparicad",
	"papead",
	"parabenizad",
	"parad",
	"parafrasead",
	"parafusad",
	"paralisad",
	"paralizad",
	"parasitad",
	"parcelad",
	"parecid",
	"parid",
	"parlad",
	"parodiad",
	"participad",
	"partid",
	"partilhad",
	"pasmad",
	"passad",
	"passarinhad",
	"passead",
	"pastad",
	"pasteurizad",
	"pastorad",
	"pastoread",
	"patentead",
	"patinad",
	"patrocinad",
	"patrulhad",
	"pausad",
	"pautad",
	"pavimentad",
	"pechinchad",
	"pedalad",
	"pedid",
	"pegad",
	"peg",
	"pêg",
	"peidad",
	"pejad",
	"pelad",
	"pelead",
	"pelejad",
	"penad",
	"penalizad",
	"pendid",
	"pendurad",
	"peneirad",
	"penetrad",
	"penhorad",
	"pensad",
	"pensionad",
	"pentead",
	"perambulad",
	"percalçad",
	"percebid",
	"percorrid",
	"percutid",
	"perdid",
	"perdoad",
	"perdurad",
	"perecid",
	"peregrinad",
	"perfeit",
	"perfilad",
	"perfilhad",
	"perfolhead",
	"perfumad",
	"perfurad",
	"perguntad",
	"perigad",
	"perlavad",
	"permanecid",
	"permead",
	"permitid",
	"permutad",
	"pernoitad",
	"pernoutad",
	"perpassad",
	"perpetrad",
	"perpetuad",
	"perseguid",
	"perseverad",
	"persignad",
	"persistid",
	"personalizad",
	"personificad",
	"perspectivad",
	"perspetivad",
	"persuadid",
	"pertencid",
	"perturbad",
	"pervertid",
	"pescad",
	"pesquisad",
	"pestanejad",
	"petiscad",
	"petrificad",
	"photographad",
	"piad",
	"picad",
	"pichad",
	"picotad",
	"pifad",
	"pigarread",
	"pigmentad",
	"pilad",
	"pilhad",
	"pinad",
	"pincelad",
	"pingad",
	"pintad",
	"pintalgad",
	"piorad",
	"pipetad",
	"pirad",
	"piratead",
	"pisad",
	"piscad",
	"pisotead",
	"pixelizad",
	"plagiad",
	"plainad",
	"planad",
	"planead",
	"planejad",
	"plangid",
	"plantad",
	"plasmad",
	"plastificad",
	"platinad",
	"plissad",
	"podad",
	"podid",
	"polid",
	"polimerizad",
	"polinizad",
	"politizad",
	"poluíd",
	"polvilhad",
	"ponderad",
	"ponhad",
	"pontuad",
	"popularizad",
	"porfiad",
	"pormenorizad",
	"portad",
	"posicionad",
	"pospost",
	"possibilitad",
	"possuíd",
	"postad",
	"post",
	"postulad",
	"potencializad",
	"poupad",
	"pousad",
	"povoad",
	"practicad",
	"praguejad",
	"prantead",
	"praticad",
	"pré-datad",
	"prédatad",
	"precedid",
	"preceituad",
	"precipitad",
	"precisad",
	"preconizad",
	"predad",
	"predestinad",
	"predicad",
	"predominad",
	"preenchid",
	"prefabricad",
	"prefaciad",
	"preferid",
	"pregad",
	"prejudicad",
	"prelibad",
	"premeditad",
	"premiad",
	"prendad",
	"prendid",
	"prensad",
	"preoccupad",
	"preocupad",
	"preparad",
	"prescrevid",
	"prescrit",
	"presenciad",
	"presentead",
	"preservad",
	"presidid",
	"pres",
	"pressagiad",
	"pressentid",
	"pressionad",
	"pressupost",
	"pressurizad",
	"prestad",
	"presumid",
	"pretendid",
	"preterid",
	"prevalecid",
	"prevaricad",
	"prevenid",
	"previst",
	"prezad",
	"principiad",
	"principia",
	"printad",
	"priorizad",
	"privad",
	"privatizad",
	"privilegiad",
	"problematizad",
	"procedid",
	"processad",
	"proclamad",
	"procrastinad",
	"procriad",
	"procurad",
	"produzid",
	"profanad",
	"proferid",
	"profetizad",
	"prognosticad",
	"programad",
	"progredid",
	"prohibid",
	"proibid",
	"projetad",
	"proliferad",
	"prolongad",
	"prometid",
	"promovid",
	"promulgad",
	"pronunciad",
	"propagad",
	"proporcionad",
	"propost",
	"propulsad",
	"prorrogad",
	"proscrit",
	"proselitad",
	"proselitizad",
	"prosperad",
	"prosseguid",
	"prostrad",
	"protagonizad",
	"protegid",
	"protestad",
	"provad",
	"providenciad",
	"provid",
	"provind",
	"provisionad",
	"provocad",
	"pruíd",
	"prurid",
	"publicad",
	"publicitad",
	"pugnad",
	"puíd",
	"pulad",
	"pulicad",
	"pulinhad",
	"pulsad",
	"pululad",
	"pulverizad",
	"punguead",
	"punid",
	"purgad",
	"purificad",
	"putrefeit",
	"puxad",
	"quadrad",
	"quadriculad",
	"quadruplicad",
	"qualificad",
	"quarentenad",
	"quebrad",
	"quebrantad",
	"quedad",
	"queimad",
	"queixad",
	"quelatad",
	"querelad",
	"querid",
	"questionad",
	"quicad",
	"quilhad",
	"quintuplicad",
	"quitad",
	"rachad",
	"raciocinad",
	"racionalizad",
	"ralad",
	"ralhad",
	"ramificad",
	"randomizad",
	"rangad",
	"rangid",
	"ranquead",
	"rapad",
	"raptad",
	"rarefeit",
	"rascad",
	"rascunhad",
	"rasgad",
	"raspad",
	"rastejad",
	"rastelad",
	"rastread",
	"rastrejad",
	"ratead",
	"ratificad",
	"reabilitad",
	"reafirmad",
	"reagid",
	"reagrupad",
	"realçad",
	"realizad",
	"realojad",
	"reanalisad",
	"reanimad",
	"reaproveitad",
	"reaquecid",
	"rearranjad",
	"rearrumad",
	"reassistid",
	"reavivad",
	"rebaixad",
	"rebatid",
	"rebatizad",
	"rebelad",
	"rebentad",
	"rebobinad",
	"rebocad",
	"rebolad",
	"rebrilhad",
	"rebuçad",
	"rebuscad",
	"recaíd",
	"recalcad",
	"recalcitrad",
	"recalculad",
	"recapitulad",
	"recarregad",
	"recead",
	"recebid",
	"receitad",
	"rechaçad",
	"reciclad",
	"recitad",
	"reclamad",
	"reclinad",
	"recobert",
	"recolhid",
	"recomeçad",
	"recomendad",
	"recompensad",
	"reconciliad",
	"reconfirmad",
	"reconfortad",
	"reconhecid",
	"reconquistad",
	"reconsiderad",
	"reconstituíd",
	"recontad",
	"reconvocad",
	"recopiad",
	"recordad",
	"recorrid",
	"recortad",
	"recostad",
	"recozid",
	"recread",
	"recriad",
	"recristalizad",
	"recrudescid",
	"recrutad",
	"rectificad",
	"recuad",
	"recuperad",
	"recurvad",
	"recusad",
	"redatad",
	"redefinid",
	"redescobert",
	"redescrit",
	"redigid",
	"redigitad",
	"redimid",
	"redirecionad",
	"redobrad",
	"reduzid",
	"reelegid",
	"reembolsad",
	"reencarnad",
	"reenchid",
	"reencontrad",
	"reenviad",
	"reescrit",
	"reestruturad",
	"refeit",
	"referenciad",
	"referid",
	"refinad",
	"refletid",
	"reflorestad",
	"refogad",
	"reforçad",
	"reformad",
	"reformulad",
	"refratad",
	"refread",
	"refrescad",
	"refrigerad",
	"refugiad",
	"refutad",
	"regad",
	"regatead",
	"regenerad",
	"regid",
	"registad",
	"registrad",
	"regozijad",
	"regressad",
	"regulad",
	"regulamentad",
	"regularizad",
	"regurgitad",
	"reinad",
	"reiniciad",
	"reinstalad",
	"reinventad",
	"reiterad",
	"reivindicad",
	"rejeitad",
	"rejeytad",
	"rejogad",
	"rejuvenescid",
	"relacionad",
	"relatad",
	"relembrad",
	"relid",
	"relinchad",
	"relutad",
	"reluzid",
	"relvad",
	"remad",
	"remanescid",
	"rematad",
	"remedad",
	"remediad",
	"remendad",
	"remetid",
	"remexid",
	"remid",
	"remodelad",
	"remontad",
	"removid",
	"remunerad",
	"renascid",
	"rendad",
	"renderizad",
	"rendid",
	"renegad",
	"renhid",
	"renomead",
	"renovad",
	"renunciad",
	"reocorrid",
	"reordenad",
	"reorganizad",
	"reoxidad",
	"reparad",
	"repartid",
	"repassad",
	"repelid",
	"repensad",
	"repetid",
	"repisad",
	"replantad",
	"replicad",
	"reportad",
	"repost",
	"repousad",
	"repreendid",
	"representad",
	"reprimendad",
	"reprimid",
	"reprisad",
	"reprocessad",
	"reprochad",
	"reproduzid",
	"reprovad",
	"repugnad",
	"reputad",
	"requentad",
	"requerid",
	"requestad",
	"requisitad",
	"rescindid",
	"resenhad",
	"reservad",
	"resfolegad",
	"resfriad",
	"resgatad",
	"resguardad",
	"residid",
	"resignad",
	"resistid",
	"resmungad",
	"resolvid",
	"respeitad",
	"respigad",
	"respirad",
	"resplandecid",
	"resplandescid",
	"resplendecid",
	"respondid",
	"responsabilizad",
	"ressaltad",
	"ressalvad",
	"ressarcid",
	"ressecad",
	"ressentid",
	"ressoad",
	"ressonad",
	"ressurgid",
	"ressuscitad",
	"restabelecid",
	"restad",
	"restaurad",
	"restituíd",
	"restringid",
	"resultad",
	"resumid",
	"resvalad",
	"retalhad",
	"retaliad",
	"retardad",
	"retes",
	"reticulad",
	"retid",
	"retificad",
	"retinid",
	"retirad",
	"retocad",
	"retomad",
	"retornad",
	"retorquid",
	"retraíd",
	"retratad",
	"retribuíd",
	"retrocedid",
	"retrucad",
	"reunid",
	"reutilizad",
	"revelad",
	"reverberad",
	"reverenciad",
	"revertid",
	"revestid",
	"revigorad",
	"revisad",
	"revistad",
	"revist",
	"revitalizad",
	"revogad",
	"revoltad",
	"revolvid",
	"rezad",
	"ribombad",
	"riçad",
	"ricochetead",
	"ridicularizad",
	"rilhad",
	"rimad",
	"ripad",
	"riscad",
	"ritmad",
	"rivalizad",
	"rocad",
	"roçad",
	"rociad",
	"rodad",
	"rodead",
	"rogad",
	"roíd",
	"rolad",
	"romanizad",
	"rompid",
	"roncad",
	"ronronad",
	"rosnad",
	"rotacionad",
	"rotad",
	"rotead",
	"rot",
	"rotulad",
	"roubad",
	"ruborizad",
	"rubricad",
	"rufad",
	"rugid",
	"rumad",
	"rumiad",
	"ruminad",
	"russificad",
	"sabid",
	"saboread",
	"sabotad",
	"sacad",
	"sacanead",
	"saciad",
	"sacolejad",
	"sacralizad",
	"sacrificad",
	"sacudid",
	"sagrad",
	"saíd",
	"salgad",
	"salientad",
	"salivad",
	"salmourad",
	"salpicad",
	"saltad",
	"saltead",
	"saltitad",
	"saluçad",
	"salvad",
	"salvaguardad",
	"salv",
	"sanad",
	"sancionad",
	"sangrad",
	"santificad",
	"sapatead",
	"sapead",
	"sapecad",
	"saquead",
	"sarad",
	"saturad",
	"saudad",
	"scintilad",
	"secad",
	"secretad",
	"secundad",
	"sedad",
	"sedimentad",
	"seduzid",
	"segad",
	"segmentad",
	"segredad",
	"seguid",
	"segurad",
	"selad",
	"seleccionad",
	"selecionad",
	"selectad",
	"seletad",
	"semead",
	"semelhad",
	"semicerrad",
	"sensualizad",
	"sentad",
	"sentenciad",
	"sentid",
	"separad",
	"sepultad",
	"sequenciad",
	"sequestrad",
	"seqüestrad",
	"serenad",
	"seriad",
	"serpentead",
	"serrad",
	"serrilhad",
	"servid",
	"sibilad",
	"sid",
	"significad",
	"silenciad",
	"silvad",
	"simbolizad",
	"simplificad",
	"simulad",
	"sinalizad",
	"sincopad",
	"sincretizad",
	"sincronizad",
	"singrad",
	"sinterizad",
	"sintetizad",
	"sintonizad",
	"sistematizad",
	"sitiad",
	"situad",
	"soad",
	"sobejad",
	"sobraçad",
	"sobrad",
	"sobre-estimad",
	"sobreestimad",
	"sobrecarregad",
	"sobrepassad",
	"sobrepost",
	"sobrepujad",
	"sobrerrepresentad",
	"sobresaíd",
	"sobressaíd",
	"sobressaltad",
	"sobrestimad",
	"sobrevind",
	"sobrevivid",
	"socad",
	"sociabilizad",
	"socializad",
	"soçobrad",
	"socorrid",
	"sodomizad",
	"sofismad",
	"sofisticad",
	"sofrid",
	"solad",
	"solapad",
	"soldad",
	"soletrad",
	"solicitad",
	"solidificad",
	"soliloquiad",
	"soltad",
	"solt",
	"solubilizad",
	"soluçad",
	"solucionad",
	"somad",
	"sombread",
	"sonambulad",
	"sondad",
	"sonhad",
	"soprad",
	"sorrid",
	"sortead",
	"sortid",
	"sorvid",
	"soterrad",
	"sovad",
	"stalkead",
	"standardizad",
	"stressad",
	"suad",
	"suavizad",
	"subentendid",
	"subestimad",
	"subid",
	"subjugad",
	"sublimad",
	"sublinhad",
	"submergid",
	"subordinad",
	"subornad",
	"subscrit",
	"subsidiad",
	"subsistid",
	"substanciad",
	"substantivad",
	"substituíd",
	"subtraíd",
	"subvencionad",
	"subvertid",
	"sucedid",
	"sucumbid",
	"sufixad",
	"sufocad",
	"sugad",
	"sugerid",
	"suicidad",
	"sujad",
	"sujeitad",
	"sulcad",
	"sumariad",
	"sumid",
	"sumulad",
	"superad",
	"superestimad",
	"supervisad",
	"supervisionad",
	"suplantad",
	"suplementad",
	"suplicad",
	"suportad",
	"supost",
	"supplantad",
	"supprimid",
	"suprid",
	"suprimid",
	"supurad",
	"surdid",
	"surfad",
	"surgid",
	"surpreendid",
	"surrad",
	"surripiad",
	"surrupiad",
	"surtad",
	"suscitad",
	"suspeitad",
	"suspendid",
	"suspirad",
	"sussurrad",
	"sustad",
	"sustentad",
	"sustid",
	"systematizad",
	"tabulad",
	"tacad",
	"tachad",
	"tactead",
	"talhad",
	"tamborilad",
	"tampad",
	"tamponad",
	"tangad",
	"tangid",
	"tapad",
	"tardad",
	"tarraxad",
	"tascad",
	"tatuad",
	"taxad",
	"taxiad",
	"tchovid",
	"tecid",
	"teclad",
	"teimad",
	"telad",
	"telefonad",
	"telegrafad",
	"teleportad",
	"teletransportad",
	"televisad",
	"temid",
	"temperad",
	"tencionad",
	"tendid",
	"tensionad",
	"tentad",
	"teorizad",
	"terceirizad",
	"tergiversad",
	"terminad",
	"terrad",
	"testad",
	"testemunhad",
	"tid",
	"tilintad",
	"timbrad",
	"tingid",
	"tinid",
	"tintad",
	"tipad",
	"tipificad",
	"tirad",
	"tiranizad",
	"tiritad",
	"tirotead",
	"titilad",
	"titulad",
	"tocad",
	"tocaiad",
	"tolerad",
	"tomad",
	"tombad",
	"topad",
	"torcid",
	"tormentad",
	"tornad",
	"tornead",
	"torpedead",
	"torrad",
	"torturad",
	"tosad",
	"tosquiad",
	"tostad",
	"totalizad",
	"touread",
	"trabalhad",
	"traçad",
	"tracejad",
	"tractad",
	"traduzid",
	"traficad",
	"trahid",
	"traíd",
	"trajad",
	"tramad",
	"trancad",
	"trançad",
	"tranquilizad",
	"transad",
	"transbordad",
	"transcorrid",
	"transcrit",
	"transfectad",
	"transferid",
	"transfigurad",
	"transformad",
	"transid",
	"transitad",
	"transladad",
	"transliterad",
	"transmitid",
	"transmudad",
	"transmutad",
	"transpassad",
	"transpirad",
	"transplantad",
	"transportad",
	"transpost",
	"transtornad",
	"transubstanciad",
	"transvasad",
	"trapacead",
	"trasladad",
	"traspassad",
	"tratad",
	"trautead",
	"travad",
	"travestid",
	"trazid",
	"trefilad",
	"treinad",
	"tremeluzid",
	"tremid",
	"tremulad",
	"trenad",
	"trepad",
	"tresandad",
	"trespassad",
	"triangulad",
	"tributad",
	"tricotad",
	"trinad",
	"trincad",
	"trinchad",
	"tripad",
	"tripulad",
	"triscad",
	"triturad",
	"triunfad",
	"trocad",
	"troçad",
	"trombetead",
	"tropeçad",
	"trotad",
	"trovad",
	"trovejad",
	"trovoad",
	"trucidad",
	"truncad",
	"trunfad",
	"tumefeit",
	"tumultuad",
	"tunad",
	"turbad",
	"turvad",
	"tutead",
	"tutelad",
	"tutorad",
	"ufanad",
	"uivad",
	"ultimad",
	"ultrajad",
	"ultrapassad",
	"ululad",
	"unctad",
	"ungid",
	"unhad",
	"unificad",
	"uniformizad",
	"untad",
	"urbanizad",
	"urdid",
	"urgid",
	"urinad",
	"usad",
	"usufruíd",
	"usurpad",
	"utilizad",
	"vacad",
	"vacilad",
	"vadiad",
	"vagabundead",
	"vagad",
	"vaguead",
	"vaiad",
	"validad",
	"valid",
	"valorad",
	"valorizad",
	"valsad",
	"vampirizad",
	"vandalizad",
	"vaporizad",
	"varad",
	"varead",
	"variad",
	"varrid",
	"vasculhad",
	"vastad",
	"vaticinad",
	"vazad",
	"vaziad",
	"vedad",
	"vegetad",
	"velad",
	"velejad",
	"vencid",
	"vendad",
	"vendid",
	"venerad",
	"ventad",
	"ventilad",
	"veranead",
	"verbalizad",
	"veread",
	"vergad",
	"vergastad",
	"verificad",
	"vermelhad",
	"vermelhead",
	"vermelhejad",
	"versad",
	"versejad",
	"versificad",
	"vertid",
	"vesguead",
	"vestid",
	"vetad",
	"vexad",
	"viajad",
	"vibrad",
	"vicejad",
	"vidrad",
	"vigiad",
	"vigorad",
	"vilificad",
	"vilipendiad",
	"vincad",
	"vinculad",
	"vindimad",
	"vind",
	"vingad",
	"vinificad",
	"violad",
	"violentad",
	"virad",
	"visad",
	"visitad",
	"vislumbrad",
	"vist",
	"visualizad",
	"vitimad",
	"vitoriad",
	"vitrificad",
	"vivad",
	"vivenciad",
	"vivid",
	"voad",
	"vocalizad",
	"vociferad",
	"volatilizad",
	"voltad",
	"voltead",
	"volvid",
	"vomitad",
	"vosead",
	"votad",
	"vulcanizad",
	"vulgarizad",
	"vulnerad",
	"wikificad",
	"xeretad",
	"xerocad",
	"xingad",
	"zanzad",
	"zapead",
	"zarpad",
	"zelad",
	"zerad",
	"zicad",
	"ziguezaguead",
	"zipad",
	"zoad",
	"zoiad",
	"zombad",
	"zonad",
	"zumbid",
	"zumbificad",
	"zunid",
];
